import FJConfig from '../../../../config/FJConfig';
import styles from './FJVideoRemoveBgCustomObjectPreview.module.less';
import { useRef, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import FJLocationIcon from '../../../../assets/svg/location.svg?react';
import FJDeleteIcon from '../../../../assets/svg/delete-black.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip';
import FJConstant from '../../../../constants/FJConstant';
import FJReloadIcon from '../../../../assets/svg/reload.svg?react';
import FJResourceItemLoading from '../../../../common/components/FJResourceItemLoading/FJResourceItemLoading';
import FJUtil from '../../../../util/FJUtil';

const FJVideoRemoveBgCustomObjectPreview = ({
    setSelectObjectPreviewCanvas,
    hasPoint,
    hasPointLoading,
    onDeleteAllPoint,
    onLocationObject,
    isDisabled,
    locationIconIsDisabled,
}) => {
    const canvasRef = useRef(null);
    const [videoLoadStatus, setVideoLoadStatus] = useState(FJConstant.LOADING);
    const [videoUrl, setVideoUrl] = useState(FJConfig.nullPointVideoUrl);

    useEffect(() => {
        if (canvasRef.current) {
            setSelectObjectPreviewCanvas(canvasRef.current);
        }
    }, [setSelectObjectPreviewCanvas]);

    const onLoadVideo = useCallback(() => {
        setVideoUrl(FJUtil.getReloadNewUrl(videoUrl));
        setVideoLoadStatus(FJConstant.LOADING);
    }, [videoUrl]);

    return (
        <div className={classNames(styles.box, { [styles.flex]: !hasPoint })}>
            {hasPoint && (
                <div className={classNames(styles.header, { [styles.disabled]: isDisabled })}>
                    <div className={styles.header_title}>{FJLocalStore._('retained-object')}</div>
                    <div className={styles.header_icon_box}>
                        <FJToolTip title={FJLocalStore._('location-object')}>
                            <div
                                className={classNames(styles.header_icon_box_item, {
                                    [styles.disabled]: hasPointLoading || locationIconIsDisabled,
                                })}
                                onClick={onLocationObject}
                            >
                                <FJLocationIcon className={styles.header_icon} />
                            </div>
                        </FJToolTip>

                        <FJToolTip title={FJLocalStore._('delete')}>
                            <div
                                className={classNames(styles.header_icon_box_item, {
                                    [styles.disabled]: hasPointLoading,
                                })}
                                onClick={onDeleteAllPoint}
                            >
                                <FJDeleteIcon className={styles.header_icon} />
                            </div>
                        </FJToolTip>
                    </div>
                </div>
            )}

            <div className={classNames(styles.canvas_box, { [styles.show]: hasPoint })}>
                <canvas ref={canvasRef} className={classNames(styles.canvas)}></canvas>
            </div>

            {!hasPoint && (
                <>
                    <div className={styles.video_box}>
                        <video
                            className={classNames(styles.video, {
                                [styles.hide]: videoLoadStatus !== FJConstant.SUCCESS,
                            })}
                            onLoadedData={() => setVideoLoadStatus(FJConstant.SUCCESS)}
                            onError={() => setVideoLoadStatus(FJConstant.ERROR)}
                            src={videoUrl}
                            autoPlay
                            loop
                            muted
                        ></video>
                        {videoLoadStatus === FJConstant.LOADING && (
                            <div className={styles.video_loading}>
                                <FJResourceItemLoading />
                            </div>
                        )}

                        {videoLoadStatus === FJConstant.ERROR && (
                            <div className={styles.video_error}>
                                <FJReloadIcon onClick={onLoadVideo} className={styles.video_error_icon} />
                            </div>
                        )}
                    </div>
                    <div className={styles.content}>
                        {FJLocalStore._('click-to-select-the-objects-you-want-to-remain')}
                    </div>
                </>
            )}
        </div>
    );
};

FJVideoRemoveBgCustomObjectPreview.propTypes = {
    setSelectObjectPreviewCanvas: PropTypes.func,
    hasPoint: PropTypes.bool,
    hasPointLoading: PropTypes.bool,
    onDeleteAllPoint: PropTypes.func,
    onLocationObject: PropTypes.func,
    isDisabled: PropTypes.bool,
    locationIconIsDisabled: PropTypes.bool,
};

export default FJVideoRemoveBgCustomObjectPreview;
